import React from 'react'

export const LoaderIcon = () => {

  return (
    <div>
      <style>
      {
        `
        .loader {
          display: block;
          min-height: 64px;
          position: relative;
          width: 100%
        }
        .loader:after {
          -webkit-transform: translate(-50%, -50%);
          -moz-transform: translate(-50%, -50%);
          -o-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          background: url(http://a.espncdn.com/redesign/assets/img/icons/shim2.gif) no-repeat;
          background-position: 50% 50% !important;
          background-size: 32px 32px;
          content: \" \";
          display: table;
          height: 64px;
          left: 50%;
          position: absolute;
          top: 50%;
          width: 32px
        }
        `
      }
    </style>

    <div className="news-feed-item loader"></div>
  </div>
  )
}

export default LoaderIcon



/** WEBPACK FOOTER **
 ** ../app/components/common/LoaderIcon.jsx
 **/